import React, {useEffect, useState} from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import DrawTable from '../../components/DrawTable';
import {GetSubscriptionType} from '.';
import moment from 'moment';
import api from '../../core/api';

const ButtonExport = ({
  subscriptionType,
  filterValue,
  adminSelect,
  newsletterType,
  onboardingUser,
  activeUser,
  business_user,
  business_user_manager,
  platform,
  b2bFilter,
  selectEmpresa,
  startDate,
  endDate,
}) => {
  const [dataExport, setDataExport] = useState([]);

  async function fetchUsers() {
    try {
      const filters = {
        name: filterValue,
        isAdmin: adminSelect,
        premium: subscriptionType,
        newsletter: newsletterType,
        onboarding: onboardingUser,
        activeUser: activeUser,
        platform: platform,
        business_id: b2bFilter,
        business_user,
        business_user_manager,
        company: selectEmpresa,
        startDate,
        endDate,
      };

      const {data} = await api.get('users', {
        params: {
          page: 1,
          pageSize: 99999999,
          filters,
          subscriptionType,
        },
      });

      const dataEx = data?.users?.map(user => {
        let plat = null;

        if (user?.transactions?.length > 0) {
          plat =
            user?.transactions[user?.transactions?.length - 1]?.platform ===
            'site'
              ? 'Site Medita'
              : user?.transactions[user?.transactions?.length - 1]?.platform ===
                'android'
              ? 'Google Play'
              : user?.transactions[user?.transactions?.length - 1]?.platform ===
                'ios'
              ? 'Apple Store'
              : 'Sem Plataforma';
        } else {
          plat =
            user?.registration_platform === 'site'
              ? 'Site Medita'
              : user?.registration_platform === 'android'
              ? 'Android'
              : user?.registration_platform === 'ios'
              ? 'Iphone'
              : 'Sem Plataforma';
        }

        const userFormatted = {
          nome: user?.name,
          email: user?.email,
          recebe_newsletter: user?.receiveNewsletter ? 'Sim' : 'Não',
          assinatura: GetSubscriptionType(user?.premium),
          data: moment.utc(user?.createdAt).format('DD/MM/YYYY'),
          onboarding: !!user?.onboarding_date ? 'Sim' : 'Não',
          usuario_ativo: user?.access_logs?.length > 0 ? 'Sim' : 'Não',
          empresa: user?.business?.corporateName || '-',
          platform: user?.business_user
            ? 'Empresa'
            : user?.premium === 'G'
            ? 'Site'
            : plat,
        };
        return userFormatted;
      });

      setDataExport(dataEx);
    } catch (err) {
    } finally {
    }
  }

  useEffect(() => {
    fetchUsers();
  }, [
    filterValue,
    subscriptionType,
    b2bFilter,
    adminSelect,
    newsletterType,
    onboardingUser,
    activeUser,
    platform,
    selectEmpresa,
    startDate,
    endDate,
  ]);

  return (
    <>
      <ReactHTMLTableToExcel
        id="partners-table-xls-button"
        table="partners-to-xls"
        className="download-table-xls-button-flex"
        filename={`users_${new Date()}`}
        sheet="tablexls"
        buttonText="Exportar Usuários"
      />
      <div style={{visibility: 'hidden', height: 10}}>
        {DrawTable(
          [
            'Nome',
            'Email',
            'Recebe Newsletter',
            'Assinatura',
            'Data',
            'Onboarding',
            'Empresa',
            'Local de contratação',
            'Usuários Ativos',
          ],
          dataExport.map(user => [
            user.nome,
            user.email,
            user.recebe_newsletter,
            user.assinatura,
            user.data,
            user.onboarding,
            user.empresa,
            user.platform,
            user.usuario_ativo,
          ]),
          'partners-to-xls',
        )}
      </div>
    </>
  );
};

export default ButtonExport;
